import { fork } from "redux-saga/effects"

import { handleGetServiceDetail } from "sagas/service"

export default function* rootSaga() {
  yield fork(handleGetServiceDetail)
}
